

















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import OrganizationType from '@/model/typelist/OrganizationType';
import { COLLECTION_ORGANIZATIONS, COLLECTION_ROLES, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import * as firebase from 'firebase/app';
import { Cropper } from 'vue-advanced-cropper'
import Members from '@/model/Member';
import Organization from '@/model/Organization';

@Component({
  components: {
    Cropper,
  },
})
export default class EditOrg extends Vue {
  dialog = false;

  loading = false;

  searchKey = '';

  selected = false;

  file = {}as any;

  backFile = {} as any;

  cropImg= '';

  cropBackImg= '';

  photoURL = '';

  backPhotoURL = '';

  editProfile() {
    this.dialog = true;
  }
  // eslint-disable-next-line
  get items() {
    return OrganizationType.allOrgTypes();
  }

  $refs!: {
    fileInput: HTMLFormElement;
    backFileInput: HTMLFormElement;
    cropper: HTMLFormElement;
    cropper1: HTMLFormElement;
  };

  cropPhoto() {
    this.cropImg = this.$refs.cropper.getResult().canvas.toDataURL();
  }

  cropCoverPhoto() {
    this.cropBackImg = this.$refs.cropper1.getResult().canvas.toDataURL();
  }

  pickFile() {
    this.$refs.fileInput.click();
  }

  pickBackFile() {
    this.$refs.backFileInput.click();
  }

  onFilePick(event: any) {
    [this.file] = event.target.files;
    const fr = new FileReader();
    fr.onload = () => {
      this.photoURL = fr.result as string;
    };
    fr.readAsDataURL(this.file);
  }

  onPick(event: any) {
    [this.backFile] = event.target.files;
    const fr = new FileReader();
    fr.onload = () => {
      this.backPhotoURL = fr.result as string;
    };
    fr.readAsDataURL(this.backFile);
  }

  get org() {
    return this.$store.state.orgObj;
  }

  submitSearch(searchKey: any) {
    this.$store.dispatch('findModerator', searchKey);
  }

  get moderator() {
    const mod = this.$store.state.moderators;
    return mod[0];
  }

  async parsedOrg() {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.uid);
    clone.type = { ...this.org.type };
    clone.description = this.org.description;
    clone.address = this.org.address;
    const list = [] as any;
    clone.members.forEach((m: any) => {
      const mem = new Members();
      mem.id = m.id;
      mem.status = m.status;
      mem.role = FirebaseUtil.ObjectToRef(COLLECTION_ROLES, m.role.roleType.code);
      list.push({ ...mem });
    });
    clone.members = list;
    if (this.cropImg) {
      await this.loadImage(this.org.id, this.file, this.cropImg).then((result: any) => {
        clone.photoURL = result;
      });
    }
    if (this.cropBackImg) {
      await this.loadImage(clone.id, this.backFile, this.cropBackImg).then((result: any) => {
        clone.backImgURL = result;
      });
    }
    return clone;
  }

  async UpdateOrg() {
    this.loading = true;
    await this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: await this.parsedOrg(),
    });
    this.$router.push('/register');
    this.dialog = false;
    this.formClear();
  }
  // eslint-disable-next-line
  async loadImage(id: string, file: any, url: string) {
    let imgUrl = '';
    const promise = await new Promise((resolve: any) => {
      const profileImageRef = firebase
        .storage()
        .ref()
        .child(`${id}/${file.name}`);
      profileImageRef.putString(url, 'data_url').then(() => {
        profileImageRef.getDownloadURL().then((downloadURL: any) => {
          imgUrl = downloadURL;
          resolve();
        });
      });
    });
    return imgUrl;
  }

  formClear() {
    this.searchKey = '';
    this.$store.commit('setModEmpty', []);
    this.selected = false;
    this.loading = false;
  }

  close() {
    this.dialog = false;
    this.formClear();
  }
}
